export default __webpack_public_path__ + "static/media/blog-img233.f87919b6.jpg";